import React, { useState } from 'react';
import { Chip, Menu, MenuItem, Box } from '@mui/material';
import { FaChevronDown } from 'react-icons/fa';
import PropTypes from 'prop-types';
import {
  TALKING_POINT_STATUSES,
  getStatusColor,
  getStatusTextColor,
  getStatusText,
} from '../../../constants/talkingPointStatuses';

const TalkingPointStatusSelector = ({
  status,
  onChange,
  disabled = false,
  size = 'small',
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (!disabled) {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleSelect = (newStatus) => (event) => {
    event.stopPropagation();
    if (newStatus !== status) {
      onChange(newStatus);
    }
    handleClose();
  };

  const currentStatus = status || TALKING_POINT_STATUSES.PENDING;

  return (
    <>
      <Chip
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {getStatusText(currentStatus)}
            {!disabled && <FaChevronDown size={10} />}
          </Box>
        }
        size={size}
        onClick={handleClick}
        sx={{
          backgroundColor: getStatusColor(currentStatus),
          color: getStatusTextColor(currentStatus),
          fontWeight: 500,
          fontSize: size === 'small' ? '11px' : '12px',
          cursor: disabled ? 'default' : 'pointer',
          '&:hover': {
            backgroundColor: disabled ? getStatusColor(currentStatus) : getStatusColor(currentStatus),
            filter: disabled ? 'none' : 'brightness(0.95)',
          },
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {Object.values(TALKING_POINT_STATUSES).map((statusOption) => (
          <MenuItem
            key={statusOption}
            onClick={handleSelect(statusOption)}
            selected={statusOption === currentStatus}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              minWidth: 120,
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: getStatusTextColor(statusOption),
              }}
            />
            {getStatusText(statusOption)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

TalkingPointStatusSelector.propTypes = {
  status: PropTypes.oneOf(Object.values(TALKING_POINT_STATUSES)),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default TalkingPointStatusSelector;
